export default __webpack_public_path__ + "static/media/image-cabal.15decace.svg";